<div class="container">
    <div *ngIf="isLoading" class="row center">
        <div class="spinner-border text-danger" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>

    <div *ngIf="!isLoading" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12">
            <div class="col-md-12 col-xs-12 mb-10">
                <h2>Set Limit</h2>
            </div>

            <form [formGroup]="limitForm" (ngSubmit)="onSubmit()">
                <div class="col-md-12 col-xs-12" style="margin-top:20px">
                    <label for="email" class="col-md-2 control-label" style="padding: 0;">SELECT
                        WEBSITE</label>
                    <div class="col-md-3">
                        <select formControlName="sites" class="form-control">
                            <option *ngFor="let site of websites" value="{{ site.value }}">{{ site.key }}</option>
                        </select>
                    </div>
                </div>

                <div class="col-lg-12 col-xs-12">
                    <div class="content_bg x_panel">
                        <h4 class="page-header">Set Auto Odds Min Max</h4>
                        <div class="col-lg-4 col-xs-6" style="margin-bottom: 5px; /* padding: 0; */">
                            <label> Min
                                <input type="number" class="form-control" formControlName="oddsMin"
                                    placeholder="Min Bet" />
                                <div *ngIf="submitted && f.oddsMin.errors" class="invalid-feedback">
                                    <div *ngIf="f.oddsMin.errors.required">Min is required</div>
                                </div>
                            </label>
                        </div>
                        <div class="col-lg-4 col-xs-6" style="margin-bottom: 5px;">
                            <label> Max <input type="number" class="form-control" formControlName="oddsMax"
                                    placeholder="Max Bet" />
                                <div *ngIf="submitted && f.oddsMax.errors" class="invalid-feedback">
                                    <div *ngIf="f.oddsMax.errors.required">Max is required</div>
                                </div>
                            </label>
                        </div>
                        <div class="col-lg-4 col-xs-6" style="margin-bottom: 5px;">
                            <label> Profit/Loss <input type="number" class="form-control" min="0"
                                    formControlName="oddsProfitLoss" placeholder="Odds Profit Loss" />
                                <div *ngIf="submitted && f.oddsProfitLoss.errors" class="invalid-feedback">
                                    <div *ngIf="f.oddsProfitLoss.errors.required">Profit/Loss is required</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12 col-xs-12">
                    <div class="content_bg x_panel">
                        <h4 class="page-header">Set BookMaker Min Max</h4>
                        <div class="col-lg-4 col-xs-6" style="margin-bottom: 5px; /* padding: 0; */">
                            <label> Min <input type="number" class="form-control" formControlName="bookMin"
                                    placeholder="Min Bet" />
                                <div *ngIf="submitted && f.bookMin.errors" class="invalid-feedback">
                                    <div *ngIf="f.bookMin.errors.required">Min is required</div>
                                </div>
                            </label>
                        </div>
                        <div class="col-lg-4 col-xs-6" style="margin-bottom: 5px;">
                            <label> Max <input type="number" class="form-control" formControlName="bookMax"
                                    placeholder="Max Bet" />
                                <div *ngIf="submitted && f.bookMax.errors" class="invalid-feedback">
                                    <div *ngIf="f.bookMax.errors.required">Max is required</div>
                                </div>
                            </label>
                        </div>
                        <div class="col-lg-4 col-xs-6" style="margin-bottom: 5px;">
                            <label> Profit/Loss
                                <input type="number" class="form-control" min="0" formControlName="bookProfitLoss"
                                    placeholder="BookMaker Profit Loss" />
                                <div *ngIf="submitted && f.bookProfitLoss.errors" class="invalid-feedback">
                                    <div *ngIf="f.bookProfitLoss.errors.required">Profit/Loss is required</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12 col-xs-12">
                    <div class="content_bg x_panel">
                        <h4 class="page-header">Set Fancy Min Max</h4>
                        <div class="col-lg-4 col-xs-6" style="margin-bottom: 5px; /* padding: 0; */">
                            <label> Min <input type="number" class="form-control" formControlName="fancyMin"
                                    placeholder="Min Bet" />
                                <div *ngIf="submitted && f.fancyMin.errors" class="invalid-feedback">
                                    <div *ngIf="f.fancyMin.errors.required">Min is required</div>
                                </div>
                            </label>
                        </div>
                        <div class="col-lg-4 col-xs-6" style="margin-bottom: 5px;">
                            <label> Max <input type="number" class="form-control" formControlName="fancyMax"
                                    placeholder="Max Bet" />
                                <div *ngIf="submitted && f.fancyMax.errors" class="invalid-feedback">
                                    <div *ngIf="f.fancyMax.errors.required">Max is required</div>
                                </div>
                            </label>
                        </div>
                        <div class="col-lg-4 col-xs-6" style="margin-bottom: 5px;">
                            <label> Profit/Loss <input type="number" class="form-control" min="0"
                                    formControlName="fancyProfitLoss" placeholder="Fancy Profit Loss" />
                                <div *ngIf="submitted && f.fancyProfitLoss.errors" class="invalid-feedback">
                                    <div *ngIf="f.fancyProfitLoss.errors.required">Profit/Loss is required</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-xs-12" style="margin-bottom: 5px; /* text-align: center; */">
                    <br />
                    <button [disabled]="submitted && limitForm.invalid" class="btn btn-success" style="width: 100%;">SET
                        LIMIT</button>
                </div>
            </form>
        </div>
    </div>
</div>